import { ImportUsersBase } from "./ImportUsersBase";

export const ImportDrivers = () => (<ImportUsersBase defaultRoleGroup="Drivers" />);